import ReactGA from "react-ga";

class Utilities {
  constructor() {}

  createLocalId() {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 16; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  trackPageview = url => {
    if (window.location.hostname.indexOf("http://frameit.com.sg") !== -1) {
      ReactGA.initialize("GTM-KJDS6BX");
      ReactGA.pageview("/" + url);
    } else if (
      window.location.hostname.indexOf("http://frameit.com.my") !== -1
    ) {
      ReactGA.initialize("GTM-KNM2HC9");
      ReactGA.pageview("/" + url);
      console.log("TODO SET ANALYTICS");
    }
  };

  isTooBigToPrint = (height, width) => {
    // console.log(height * width);
    if (height * width > 15000) {
      return true;
    } else {
      return false;
    }
  };

  isOverSized = (height, width) => {
    let artWorkLargerOversized = 120;
    let artWorkSmallerOversized = 80;

    let bigger = width > height ? width : height;
    let smaller = width > height ? height : width;

    if (bigger > artWorkLargerOversized || smaller > artWorkSmallerOversized) {
      return true;
    } else {
      return false;
    }
  };

  setInitialFrameSize = minFrame => {
    let priceDefinitions = JSON.parse(localStorage.getItem("priceDefinitions"));
    let frame = priceDefinitions
      .filter(item => {
        return item.type === "frame" && item.isInStock
      })
      .sort((a, b) => a.orderSort - b.orderSort)
      .filter(item => {
        return parseFloat(item.frameWidth) >= minFrame;
      })[0];
    return frame;
  };

  setMatBorderColor = (height, width) => {
    // Set the mat colour for the first part of the dropdown

    function isOverSized(height, width) {
      let artWorkLargerOversized = 120;
      let artWorkSmallerOversized = 80;

      let bigger = width > height ? width : height;
      let smaller = width > height ? height : width;

      if (
        bigger > artWorkLargerOversized ||
        smaller > artWorkSmallerOversized
      ) {
        return true;
      } else {
        return false;
      }
    }

    const isMatBoardOversized = isOverSized(height, width);
    let priceDefinitions = JSON.parse(localStorage.getItem("priceDefinitions"));
    let matte = priceDefinitions
      .filter(item => {
        return item.type === "matte-color";
      })
      .filter(item => {
        return item.oversizedMattColor === isMatBoardOversized;
      })[0];
    return matte.name;
  };

  pythagorean = (sideA, sideB) => {
    return Math.sqrt(Math.pow(sideA, 2) + Math.pow(sideB, 2));
  };

  getBase64 = file => {
    return new Promise(function(resolve, reject) {
      let reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = function() {
        resolve(reader.result);
      };

      reader.onerror = function(error) {
        reject(error);
      };
    });
  };

  createCartItem = () => {
    let priceDefinitions = JSON.parse(localStorage.getItem("priceDefinitions"));

    if (!this.isENU(priceDefinitions)) {
      let newId = this.createLocalId();

      let glazing = JSON.parse(JSON.stringify(priceDefinitions))
        .filter(item => item.type === "glazing")
        .map(item => {
          item.value = item.name;
          return item;
        })[0].value;

      let frameStyle = priceDefinitions
        .filter(item => item.type === "frame")
        .map(item => {
          return {
            value: item.description
          };
        })[0].value;

      let frameId = priceDefinitions
        .filter(item => item.type === "frame")
        .map(item => {
          return {
            value: item.adminId
          };
        })[0].value;

      let backing = priceDefinitions
        .filter(item => item.type === "backing")
        .map(item => {
          item.value = item.name;
          return item;
        })[0].value;

      let matte = priceDefinitions.filter(item => {
        return item.type === "matte-color";
      })[0]; // }) //   return item.oversizedMattColor === false; // .filter(item => {

      // let hangingDefinition = priceDefinitions.filter(item => item.type === "hanging-components").map(item => {
      //     return item;
      // });
      //
      // console.log(hangingDefinition)
      //
      // hangingDefinition = hangingDefinition[hangingDefinition.length-1].component;

      let cartItem = {
        localId: newId,

        artworkHeight: 43.2,
        artworkWidth: 27.9,

        artworkHeightNominal: 43.2,
        artworkWidthNominal: 27.9,

        externalHeightNominal: 46.1,
        externalWidthNominal: 30.8,

        // frameHeightNominal: 20.1,
        // frameWidthNominal: 30,

        windowHeightNominal: 42.1,
        windowWidthNominal: 26.8,

        matteBoardHeight: 43.2,
        matteBoardWidth: 27.9,

        internalHeight: 43.3,
        internalWidth: 28,

        rabbetEdgeHeight: 42.1,
        rabbetEdgeWidth: 26.8,

        glazing: glazing,
        matteWidth: 0,
        frameStyle: frameStyle,
        frameSelected: false,
        frameId: frameId,
        backing: backing,
        hanging: "Not Selected",
        addeddToCart: false,
        matteColor: matte.name,
        matteColorSelected: false,
        matteId: matte.adminId,
        popularSize: null,
        customSizes: true,
        suggestedMatteWidth: false,
        quantity: 1,
        matBorderSelected: false,
        matBorderCounter: 0,
        matColorSelected: false,
        isOversized: false
      };

      // Adding id to cart
      let cart = JSON.parse(localStorage.getItem("cart"));
      if (this.isENU(cart)) {
        cart = [];
      }

      cart.push(newId);
      localStorage.setItem("cart", JSON.stringify(cart));

      // Adding cart item to local
      localStorage.setItem(newId, JSON.stringify(cartItem));

      return newId;
    } else {
      window.location.href = "/";
      return null;
    }
  };

  isENU = field => {
    if (field === undefined || field === null || field === "") {
      return true;
    } else {
      return false;
    }
  };

  isNU = field => {
    if (field === undefined || field === null) {
      return true;
    } else {
      return false;
    }
  };

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  getBase64 = file => {
    return new Promise(function(resolve, reject) {
      let reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = function() {
        resolve(reader.result);
      };

      reader.onerror = function(error) {
        reject(error);
      };
    });
  };

  formatDate = (dateObj, format) => {
    var str = new Date();

    if (dateObj !== undefined) {
      str = new Date(dateObj);
    }

    // if ( (typeof dateObj === 'string') || (typeof dateObj === 'number') ) {
    //     str = new Date(dateObj * 1000);
    // }

    var dateStr = "";
    var monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];

    var months;
    var days;
    var years;
    var hours;
    var minutes;

    switch (format) {
      case "DD/MM/YYYY":
        months = str.getMonth() + 1;
        days = str.getDate();
        years = str.getFullYear();
        if (months < 10) months = "0" + months;
        if (days < 10) days = "0" + days;
        dateStr = days + "-" + months + "-" + years;
        break;

      case "YYYY-MM-DD":
        months = str.getMonth() + 1;
        days = str.getDate();
        years = str.getFullYear();
        if (months < 10) months = "0" + months;
        if (days < 10) days = "0" + days;
        dateStr = years + "-" + months + "-" + days;
        break;

      default:
        months = str.getMonth() + 1;
        if (months < 10) months = "0" + months;
        years = str.getFullYear();
        if (years < 10) years = "0" + years;
        days = str.getDate();
        if (days < 10) days = "0" + days;
        hours = str.getHours();
        if (hours < 10) hours = "0" + hours;
        minutes = str.getMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        dateStr =
          years + "-" + months + "-" + days + " " + hours + ":" + minutes;
        break;
    }

    return dateStr;
  };
}

export default Utilities;



// WEBPACK FOOTER //
// ./src/components/Utilities.js